/**
 * Clears caches available via the Cache Storage API and then reloads the page.
 */
export async function clearCachesAndReload(): Promise<void> {
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
    } catch (error) {
      console.error('Error clearing caches:', error);
    }
  }
  window.location.reload();
}
